module.exports = __webpack_public_path__ + "static/img/6828987f18498ee19ec980f29c37ba55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_disable_02.png
// module id = fdXq
// module chunks = 1